export default {
  categories: [],
  brands: [],
  hierarchyCategories: [],
  groupCategories: [],
  categoryAttributes: {},
  exchangeRates: null,
  selectedCategoryId: null,
  isLoading: {
    categories: false,
    brands: false,
    hierarchyCategories: false,
    groupCategories: false,
    categoryAttributes: false,
    exchangeRates: false,
  },
  errors: {
    categories: null,
    brands: null,
    hierarchyCategories: null,
    groupCategories: null,
    categoryAttributes: null,
    exchangeRates: null,
  },
};
